import Util from "../Util.js";
/* eslint-disable no-console */
const calculator = (model, activeRole) => {
  const {
    single,
    multiple,
    resourceType
  } = model;
  const {
    userRoles
  } = activeRole;
  const roles = userRoles.filter(role => role.resourceType === resourceType);
  if (roles.length === 1) {
    if (single == null) {
      return null;
    }
    const match = {
      params: {
        resourceId: roles[0].resourceId,
        persona: activeRole.name
      }
    };
    const url = Util.resolve(single, match);
    if (single.indexOf(':resourceId') === -1) {
      console.warn('InitialUrlCalculator: single url template does not contain :resourceId token');
    }
    return url;
  }
  if (multiple == null) {
    return null;
  }
  const match = {
    params: {
      persona: activeRole.name
    }
  };
  return Util.resolve(multiple, match);
};
export default {
  calculator
};